var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("layout", [
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-sm-12" },
        [
          _c("NotiificationList", {
            attrs: {
              moduleCode: _vm.moduleCode,
              panelId: _vm.pageID,
              url: _vm.url.getList,
              canDetail: _vm.canDetail,
              canAdd: _vm.canAdd,
              canEdit: _vm.canEdit,
              canDelete: _vm.canDelete,
              routeEdit: `${_vm.moduleCode}.${_vm.pageID}.show`,
              modules: _vm.lists.modules,
              channels: _vm.lists.channels,
            },
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }